import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKling = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.51035 11.0625C4.93319 9.7699 5.49128 8.5255 6.17535 7.35003C8.81703 2.77335 12.6712 0.0525263 14.7837 1.27167C10.032 -1.47165 3.83203 0.370066 0.935345 5.38667C0.58964 5.9852 0.300335 6.61457 0.0711653 7.26667C-0.144655 7.88253 0.147845 8.54503 0.712845 8.87167L4.51035 11.0633V11.0625Z",
			fill: "url(#paint0_radial_17396_28068)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4929 8.05469C15.0699 9.34736 14.5115 10.5918 13.8271 11.7672C11.1854 16.3439 7.33125 19.0655 5.21875 17.8455C9.97125 20.5897 16.1712 18.7472 19.0679 13.7305C19.4135 13.1322 19.7028 12.5032 19.9321 11.8514C20.1479 11.2364 19.8554 10.573 19.2904 10.2472L15.4929 8.05551V8.05469Z",
			fill: "url(#paint1_radial_17396_28068)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8258 11.7665C16.4675 7.18988 16.8975 2.49152 14.7841 1.27152C12.6733 0.0523812 8.8191 2.77488 6.17578 7.34988C7.9041 4.3582 11.0166 2.9207 13.1291 4.13988C15.2408 5.35988 15.5525 8.7732 13.825 11.7657L13.8258 11.7665Z",
			fill: "url(#paint2_linear_17396_28068)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.17517 7.35156C3.53349 11.9282 3.10349 16.6266 5.21685 17.8457C7.32849 19.0657 11.1827 16.3441 13.8252 11.7674C12.0969 14.7599 8.98435 16.1974 6.87185 14.9774C4.76017 13.7582 4.44849 10.3441 6.17599 7.35238L6.17517 7.35156Z",
			fill: "url(#paint3_linear_17396_28068)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_17396_28068",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(4.31118 10.9475) rotate(-59.132) scale(12.1456 16.644)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .095,
						stopColor: "#FFF959"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .326,
						stopColor: "#0DF35E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .64,
						stopColor: "#0BF2F9"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#04A6F0"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_17396_28068",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(15.6915 8.16965) rotate(120.868) scale(12.1456 16.644)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .095,
						stopColor: "#FFF959"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .326,
						stopColor: "#0DF35E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .64,
						stopColor: "#0BF2F9"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#04A6F0"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_17396_28068",
				x1: 12.9825,
				y1: 1.08152,
				x2: 15.0525,
				y2: 7.8007,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#003EFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0BFFE7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_17396_28068",
				x1: 7.01849,
				y1: 18.0366,
				x2: 4.94849,
				y2: 11.3174,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#003EFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0BFFE7"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgKling);
export default ForwardRef;
